export var ENTER = 'ENTER';
export var UPDATE = 'UPDATE';
export var LEAVE = 'LEAVE';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-move/es/core/types.js
// module id = 989
// module chunks = 0